import { clearTokens, queryClient, storage } from '@frontend/shared';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * `clearTokens` de `libs/shared` ne vide que les queries passenger. Les queries
 * extranet sont préfixées `['extranet', …]` : sans ce nettoyage, `/v1/users/me`
 * (staleTime 60 s) survivrait à une reconnexion sous un autre compte.
 * Les queries publiques (`['extranet-public', …]`) ne sont pas touchées.
 */
export const clearExtranetCache = () => {
  queryClient.removeQueries({ queryKey: ['extranet'] });
};

export const endSession = async () => {
  storage.removeItem('tokens');
  await clearTokens(queryClient);
  clearExtranetCache();
};

export const useLogout = () => {
  const navigate = useNavigate();
  return useCallback(async () => {
    await endSession();
    navigate('/login', { replace: true });
  }, [navigate]);
};
